import { usePostHog } from "posthog-js/react";

export function useTrackPlacementTest() {
  const posthog = usePostHog();

  const trackStartFromScratch = () => {
    posthog.capture("placement_test_start_from_scratch");
  };

  const trackBeginPlacementTest = () => {
    posthog.capture("placement_test_begin");
  };

  return {
    trackStartFromScratch,
    trackBeginPlacementTest,
  };
} 